export type SidebarMode = 'default' | 'customization';
export const defaultSectionOrder = [
  'customerInfo',
  'knowledge',
  'nativeIntegration',
  'customIntegration',
] as const;

export type SidebarSectionId = (typeof defaultSectionOrder)[number];

export type SidebarCardId =
  | 'contact'
  | 'contact-memories'
  | 'custom-fields'
  | 'history'
  | 'tracking'
  | 'knowledge-suggestions'
  | 'elevio'
  | (string & {});

export const defaultCustomerInfoOrder: readonly SidebarCardId[] = [
  'contact',
  'contact-memories',
  'custom-fields',
  'history',
  'tracking',
];

export const defaultKnowledgeOrder: readonly SidebarCardId[] = [
  'knowledge-suggestions',
  'elevio',
];

/**
 * Flat card model — used by the `sidebar-cards-admin-management` feature. A card
 * is identified by its source (`cardType`) plus an id that is only unique within
 * that source, so the two are combined into a namespaced {@link SidebarCardKey}
 * (`static:contact`, `native:<integrationKey>`, `custom:<customCardId>`) to avoid
 * collisions between dynamic sources.
 */
export type SidebarCardType = 'static' | 'native' | 'custom';

/** Built-in cards that always originate from the app itself. */
export type StaticSidebarCardId =
  | 'contact'
  | 'contact-memories'
  | 'custom-fields'
  | 'history'
  | 'tracking'
  | 'knowledge-suggestions'
  | 'elevio';

/** A card's source + its source-local id. */
export type SidebarCardRef = {
  readonly cardType: SidebarCardType;
  readonly cardId: string;
};

/** Namespaced, collision-free key for a card in the flat model. */
export type SidebarCardKey = `${SidebarCardType}:${string}`;
